import { RELEASE_TIMEOUT_MS } from './constants';

export const withTimeout = (promise, ms = RELEASE_TIMEOUT_MS) =>
  Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Lock release timed out')), ms);
    }),
  ]);

export const globalReleaseGeneration = { current: 0 };
